import { apiFetch } from "./client";

/* ---------- Response types ---------- */

interface TokenLedgerEntry {
  id: string;
  user_id: string;
  type: string;
  amount: number;
  balance_after: number;
  reason: string | null;
  created_at: string;
}

interface WebhookEvent {
  id: string;
  provider: string;
  event_type: string;
  status: "processed" | "failed" | "pending";
  payload_summary: string | null;
  created_at: string;
}

export interface UserBillingData {
  user_id: string;
  email: string;
  nickname: string;
  subscription_status: string;
  plan: string;
  token_balance: number;
  token_ledger: TokenLedgerEntry[];
  webhook_events: WebhookEvent[];
}

interface GrantTokensResponse {
  ledger_entry_id: string;
  new_balance: number;
}

interface ResyncResponse {
  synced: boolean;
}

interface ReplayResponse {
  replayed: boolean;
  new_status: string;
}

/* ---------- API calls ---------- */

export async function fetchUserBilling(
  userId: string,
): Promise<UserBillingData> {
  const res = await apiFetch<{ data: UserBillingData }>(
    `/admin/billing/users/${userId}`,
  );
  return res.data;
}

export async function grantTokens(
  userId: string,
  amount: number,
  reason: string,
): Promise<GrantTokensResponse> {
  const res = await apiFetch<{ data: GrantTokensResponse }>(
    `/admin/billing/users/${userId}/grant-tokens`,
    {
      method: "POST",
      body: JSON.stringify({ amount, reason }),
    },
  );
  return res.data;
}

export async function resyncEntitlement(
  userId: string,
  reason: string,
): Promise<ResyncResponse> {
  const res = await apiFetch<{ data: ResyncResponse }>(
    `/admin/billing/users/${userId}/resync-entitlement`,
    {
      method: "POST",
      body: JSON.stringify({ reason }),
    },
  );
  return res.data;
}

export async function replayWebhook(
  webhookEventId: string,
  reason: string,
): Promise<ReplayResponse> {
  const res = await apiFetch<{ data: ReplayResponse }>(
    "/admin/billing/webhook/replay",
    {
      method: "POST",
      body: JSON.stringify({ webhook_event_id: webhookEventId, reason }),
    },
  );
  return res.data;
}
